/**
 * Generador de códigos de barra CODE 128-B como SVG, sin dependencias.
 * Es el formato estándar que leen las pistolas lectoras (alfanumérico).
 */

// Tabla oficial CODE128: anchos de barras/espacios (6 elementos por símbolo).
const PATRONES = [
  "212222", "222122", "222221", "121223", "121322", "131222", "122213", "122312",
  "132212", "221213", "221312", "231212", "112232", "122132", "122231", "113222",
  "123122", "123221", "223211", "221132", "221231", "213212", "223112", "312131",
  "311222", "321122", "321221", "312212", "322112", "322211", "212123", "212321",
  "232121", "111323", "131123", "131321", "112313", "132113", "132311", "211313",
  "231113", "231311", "112133", "112331", "132131", "113123", "113321", "133121",
  "313121", "211331", "231131", "213113", "213311", "213131", "311123", "311321",
  "331121", "312113", "312311", "332111", "314111", "221411", "431111", "111224",
  "111422", "121124", "121421", "141122", "141221", "112214", "112412", "122114",
  "122411", "142112", "142211", "241211", "221114", "413111", "241112", "134111",
  "111242", "121142", "121241", "114212", "124112", "124211", "411212", "421112",
  "421211", "212141", "214121", "412121", "111143", "111341", "131141", "114113",
  "114311", "411113", "411311", "113141", "114131", "311141", "411131", "211412",
  "211214", "211232",
];
const STOP = "2331112";
const START_B = 104;

/**
 * Devuelve un SVG (string) con el código de barras CODE128-B del texto.
 * opts: { alto (px barras), modulo (px por unidad), mostrarTexto, fontSize }
 */
export function barcodeSVG(texto, opts = {}) {
  const t = String(texto || "").trim();
  if (!t) return "";
  const alto = opts.alto ?? 48;
  const modulo = opts.modulo ?? 2;
  const mostrarTexto = opts.mostrarTexto ?? false;
  const fontSize = opts.fontSize ?? 10;
  const quiet = 10 * modulo; // zona muda obligatoria a cada lado

  // valores: Start B + caracteres (ASCII 32..126 → valor = código - 32)
  const valores = [START_B];
  for (const ch of t) {
    const code = ch.charCodeAt(0);
    valores.push(code >= 32 && code <= 126 ? code - 32 : 0);
  }
  // checksum
  let suma = START_B;
  for (let i = 1; i < valores.length; i++) suma += valores[i] * i;
  valores.push(suma % 103);

  // secuencia de anchos
  let secuencia = "";
  for (const v of valores) secuencia += PATRONES[v];
  secuencia += STOP;

  // dibujar: alterna barra/espacio empezando con barra
  let x = quiet;
  let rects = "";
  for (let i = 0; i < secuencia.length; i++) {
    const w = parseInt(secuencia[i], 10) * modulo;
    if (i % 2 === 0) rects += `<rect x="${x}" y="0" width="${w}" height="${alto}" fill="#000"/>`;
    x += w;
  }
  const ancho = x + quiet;
  const altoTotal = alto + (mostrarTexto ? fontSize + 4 : 0);
  const textoSvg = mostrarTexto
    ? `<text x="${ancho / 2}" y="${alto + fontSize + 1}" text-anchor="middle" font-family="monospace" font-size="${fontSize}" fill="#000">${t.replace(/&/g, "&amp;").replace(/</g, "&lt;")}</text>`
    : "";
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${ancho} ${altoTotal}" width="100%" height="100%" preserveAspectRatio="xMidYMid meet" shape-rendering="crispEdges">${rects}${textoSvg}</svg>`;
}
